(function () {
  function initNewsletterConsent(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.newsletter-form');

    forms.forEach(function (form) {
      if (form.dataset.newsletterConsentReady === 'true') return;

      var checkbox = form.querySelector('.newsletter-form__consent-checkbox');
      if (!checkbox) return;

      var submit = form.querySelector('[data-newsletter-submit], button[type="submit"]');
      if (!submit) return;

      var sync = function () {
        var disabled = !checkbox.checked;
        submit.disabled = disabled;
        submit.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      };

      checkbox.addEventListener('change', sync);
      form.addEventListener('submit', function (event) {
        if (checkbox.checked) return;

        event.preventDefault();
        checkbox.focus();
        sync();
      });

      form.dataset.newsletterConsentReady = 'true';
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNewsletterConsent(document);
    });
  } else {
    initNewsletterConsent(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initNewsletterConsent(event.target);
  });
})();
